import { ResponseCode } from "@/http/ResponseCode";
import { BaseResponse } from "@/typeDefine/HttpResponseType";
import { dayjs, ElLoading, ElMessage } from "element-plus";

/**
 * 全局通用方法
 */
export class UtilMethods {
    public static getDOMStyleFromCSS(cssStyleName: string): string {
        return getComputedStyle(document.documentElement).getPropertyValue(cssStyleName).trim()
    }

    //根据axios status响应码返回响应处理信息
    public static axiosResponseStatusInfo(status: number): BaseResponse {

        if (status >= 300 && status < 400) {
            return {
                code: ResponseCode.FAIL,
                message: '正在重定向'
            }
        } else if (status === 400) {
            return {
                code: ResponseCode.FAIL,
                message: '请求参数有误'
            }
        } else if (status === 401) {
            return {
                code: ResponseCode.NOT_ALLOW,
                message: '请先登录'
            }
        } else if (status === 403) {
            return {
                code: ResponseCode.NOT_ALLOW,
                message: '接口被禁止'
            }
        } else if (status === 404) {
            return {
                code: ResponseCode.FAIL,
                message: '资源不存在'
            }
        } else if (status === 500) {
            return {
                code: ResponseCode.SERVER_ERROR,
                message: '服务器异常'
            }
        } else {
            return {
                code: ResponseCode.SERVER_ERROR,
                message: '未知错误'
            }
        }
    }

    //根据状态值渲染提示弹窗
    public static showMessageToast(response: BaseResponse | undefined, isSuccessShow = true): void {
        if (!response) {
            ElMessage({
                message: '数据请求异常 Data request exception',
                type: 'error'
            })

            return
        }

        let type: 'primary' | 'success' | 'warning' | 'info' | 'error' = 'error'
        if (response.code === ResponseCode.NOT_ALLOW || response.code === ResponseCode.LOGIN) {
            type = 'warning'
        } else if (response.code === ResponseCode.OK) {
            type = 'success'
        }

        if (response.code === ResponseCode.OK && !isSuccessShow) {
            return
        }

        ElMessage({
            message: response.message,
            type
        })
    }

    public static formatDataOfPattern(date: dayjs.ConfigType, format = 'YYYY-MM-DD HH:mm:ss'): string {
        return dayjs(date).format(format)
    }

    public static getFileName(filename: string): string {
        return filename.substring(filename.lastIndexOf('/') + 1)
    }
}